// Task moderation — search/filter user tasks, delete the offending ones.

import React, { useEffect, useState } from 'react';
import { deleteTask, listTasks } from '../../services/adminService';
import DataTable from '../common/DataTable';
import ConfirmDialog from '../common/ConfirmDialog';

export default function AdminTaskModeration() {
  const [data, setData] = useState({ tasks: [], pagination: { page: 1, total: 0, page_size: 50 } });
  const [q, setQ] = useState('');
  const [category, setCategory] = useState('');
  const [userId, setUserId] = useState('');
  // Completion filter is client-side — backend has no ?completed= param.
  const [completion, setCompletion] = useState('');
  const [page, setPage] = useState(1);
  const [confirmDel, setConfirmDel] = useState(null);

  const reload = () =>
    listTasks({ q, category, user_id: userId, page })
      .then(setData)
      .catch(() => {});

  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, category, userId, page]);

  const visible = data.tasks.filter(t => {
    if (completion === 'done' && !t.completed) return false;
    if (completion === 'open' && t.completed) return false;
    return true;
  });

  const resetFilters = () => {
    setQ(''); setCategory(''); setUserId(''); setCompletion(''); setPage(1);
  };
  const hasFilters = q || category || userId || completion;

  const doDelete = async () => {
    if (!confirmDel) return;
    await deleteTask(confirmDel.id);
    setConfirmDel(null);
    reload();
  };

  return (
    <>
      <div className="portal-content-header">
        <h1>Task moderation</h1>
      </div>

      <div className="portal-filter-bar">
        <input className="portal-search" placeholder="Search task text" value={q} onChange={e => { setQ(e.target.value); setPage(1); }} />
        <input className="portal-search" style={{ flex: '0 1 160px', minWidth: 0 }} placeholder="Category" value={category} onChange={e => { setCategory(e.target.value); setPage(1); }} />
        <input className="portal-search" style={{ flex: '0 1 120px', minWidth: 0 }} placeholder="User ID" value={userId} onChange={e => { setUserId(e.target.value); setPage(1); }} />
        <select className="portal-search" value={completion} onChange={e => setCompletion(e.target.value)}>
          <option value="">Any status</option>
          <option value="open">Open</option>
          <option value="done">Done</option>
        </select>
        {hasFilters && <button type="button" className="portal-button secondary" onClick={resetFilters}>Clear</button>}
        <span className="meta">
          {completion ? `${visible.length} of ${data.pagination.total}` : data.pagination.total} tasks
        </span>
      </div>

      <DataTable
        columns={[
          { key: 'task_text', label: 'Task', render: t => (
              <span>
                <strong>{t.task_text}</strong>
                {t.description && <div style={{ color: 'var(--tudu-text-lo)', fontSize: 12, marginTop: 2 }}>{t.description}</div>}
              </span>
            ) },
          { key: 'category', label: 'Category' },
          { key: 'user', label: 'User', render: t => t.user ? `${t.user.username} (${t.user.email})` : '—' },
          { key: 'completed', label: 'Status', render: t => <span className={`badge badge-${t.completed ? 'active' : 'pending'}`}>{t.completed ? 'Done' : 'Open'}</span> },
          { key: 'created_at', label: 'Created', render: t => t.created_at ? new Date(t.created_at).toLocaleDateString() : '—' },
          { key: 'actions', label: '', render: t => <button type="button" className="portal-button danger" onClick={() => setConfirmDel(t)}>Delete</button> },
        ]}
        rows={visible}
        emptyMessage={hasFilters ? 'No tasks match the current filters.' : 'No tasks yet.'}
      />

      {data.pagination.total > data.pagination.page_size && (
        <div className="portal-pagination">
          <button type="button" className="portal-button secondary" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Prev</button>
          <span>Page {data.pagination.page}</span>
          <button type="button" className="portal-button secondary" disabled={page * data.pagination.page_size >= data.pagination.total} onClick={() => setPage(p => p + 1)}>Next</button>
        </div>
      )}

      <ConfirmDialog
        open={!!confirmDel}
        title="Delete task?"
        message={`Remove "${confirmDel?.task_text}" permanently? This deletes it from the user's view.`}
        confirmLabel="Delete"
        danger
        onConfirm={doDelete}
        onCancel={() => setConfirmDel(null)}
      />
    </>
  );
}
